import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAddPrescription } from "../../interface/GeneralResponse";

const initialState: IAddPrescription = {
  Case: "",
  Drugs: [],
};

const prescriptionFormSlice = createSlice({
  name: "prescriptionForm",
  initialState,
  reducers: {
    setFormData(state, action: PayloadAction<IAddPrescription>) {
      state.Case = action.payload.Case;
      state.Drugs = action.payload.Drugs;
    },
    resetFormData(state) {
      state.Case = initialState.Case;
      state.Drugs = initialState.Drugs;
    },
  },
});

export const { setFormData, resetFormData } = prescriptionFormSlice.actions;
export default prescriptionFormSlice.reducer;
